import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DocList from "./DocList";
import PaginationModified from "../../../data/PaginationModified";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";

const DocSidebar = ({
  userInfoData,
  isCRUDAllow,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  callFunction,
  isUid,
}) => {
  // const dispatch = useDispatch();
  const { featureDoc, featureDocLoading, featureDocError } = useSelector(
    (state) => state.features
  );

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const [activeUid, setActiveUid] = useState(
    () => allDatas.allData[0]?.uid || null
  );
  const [menuOpen, setMenuOpen] = useState(false);

  const activePageData = allDatas.allData.find(
    (page) => page.uid === activeUid
  );

  const handleSidebarToggle = () => {
    setMenuOpen(!menuOpen);
  };

  function getPagination() {
    try {
      const pagination = allDatas.pagination ? allDatas.pagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (
      !featureDocLoading &&
      !featureDocError &&
      featureDoc?.status &&
      featureDoc?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: featureDoc.data,
        pagination:
          featureDoc?.pagination?.length > 0 ? featureDoc.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [featureDocLoading, featureDocError, featureDoc]);

  useEffect(() => {
    if (allDatas.allData.length > 0 && !activeUid) {
      setActiveUid(allDatas.allData[0].uid);
    }
  }, [allDatas.allData, activeUid]);

  return (
    <>
      <div className="dl-container docs">
        {!isUid && (
          <button className="mobile-menu-btn" onClick={handleSidebarToggle}>
            ☰ Menu
          </button>
        )}

        {!isUid && (
          <div className={`dl-sidebar ${menuOpen ? "open" : ""}`}>
            <div className="dl-sidebar-content">
              {allDatas.allData.map((page) => (
                <div
                  key={page.uid}
                  className={`dl-sidebar-item ${
                    activeUid === page.uid ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveUid(page.uid);
                    setMenuOpen(false);
                  }}>
                  {/* {page.feature_name} */}
                  {page?.feature_doc_name || page?.feature_name}
                </div>
              ))}
            </div>

            <div className="dl-sidebar-pagination">
              <PaginationModified
                isPage={isPage}
                onChangePage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                pagination={getPagination()}
                isSidebar={true}
              />
            </div>
          </div>
        )}

        <div className="dl-content">
          {featureDocLoading ? (
            <ReactVortoxSpinner />
          ) : activePageData ? (
            <DocList
              tbData={activePageData}
              userInfoData={userInfoData}
              setModValues={setModValues}
              callFunction={callFunction}
              isCRUDAllow={isCRUDAllow}
            />
          ) : null}
        </div>

        {menuOpen && (
          <div className="overlay" onClick={() => setMenuOpen(false)} />
        )}
      </div>
    </>
  );
};

export default DocSidebar;
